import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';
import { ExpandMore, Help } from '@mui/icons-material';

const QuickHelp = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
        📖 Quick Help
      </Typography>

      <Accordion expanded={expanded === 'getting-started'} onChange={handleChange('getting-started')}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle2">Getting Started</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense>
            <ListItem>
              <ListItemText 
                primary="1. Select a workflow above"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="2. Check agent status (should be 🟢)"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="3. Follow the workflow steps"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="4. Review results at each step"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'blog-writer'} onChange={handleChange('blog-writer')}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle2">Blog Writer 2</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Start agents:</strong>
            </Typography>
            <Box sx={{ bgcolor: 'grey.100', p: 1, borderRadius: 1, mb: 2 }}>
              <code>uv run python start_agents.py</code>
            </Box>
            
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Location:</strong> <code>Blog Writer 2/</code>
            </Typography>
            
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Process:</strong> 4-step workflow (manual or automated)
            </Typography>
            
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>🚀 Run All:</strong> Execute complete workflow automatically
            </Typography>
            
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Manual Steps:</strong> Run each step individually when ready
            </Typography>
            
            <List dense>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText 
                  primary="✍️ Initial Draft"
                  secondary="Creates comprehensive first draft"
                  primaryTypographyProps={{ variant: 'caption' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText 
                  primary="🔍 Beginner Critique"
                  secondary="Reviews for accessibility"
                  primaryTypographyProps={{ variant: 'caption' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText 
                  primary="🎯 Expert Critique"
                  secondary="Reviews for technical accuracy"
                  primaryTypographyProps={{ variant: 'caption' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemText 
                  primary="✨ Final Blog"
                  secondary="Synthesizes into final post"
                  primaryTypographyProps={{ variant: 'caption' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
              </ListItem>
            </List>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'troubleshooting'} onChange={handleChange('troubleshooting')}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle2">Troubleshooting</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense>
            <ListItem>
              <ListItemText 
                primary="🔴 Red agents = not running"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Check terminal for agent logs"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Restart agents if needed"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Ensure .env file has ANTHROPIC_API_KEY"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          </List>
          
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Common Commands:</strong>
            </Typography>
            <Box sx={{ bgcolor: 'grey.100', p: 1, borderRadius: 1 }}>
              <code>cd "Agent Workflows/Blog Writer 2"</code><br/>
              <code>uv run python start_agents.py</code><br/>
                              <code>curl {process.env.REACT_APP_INITIAL_WRITER_URL || "http://localhost:11001"}/health</code>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Box sx={{ mt: 2 }}>
        <Chip
          icon={<Help />}
          label="Need help? Check the README.md"
          variant="outlined"
          size="small"
          clickable
        />
      </Box>
    </Box>
  );
};

export default QuickHelp;